import React, { Component } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Skeleton, Typography } from "antd"

import * as com from "../Common.js"
import { connect } from "react-redux"
import * as act from "../Store/actions"
import { UpdateChangeProgressType } from "../Store/progress"
import * as prgr from "../Store/progress"
import { fees } from "../State"

import PreQualLetterHistory from "../Application/Prequal/PrequalLetterHistory"
import { PrequalLetterHeader } from "../Application/Prequal/PrequalLetterHeader"
import { NoPrequalLetters } from "../Application/Prequal/NoPrequalLetters"

import {
  getDTI,
  getCitizenship,
  getOccupancy,
  getPropertyType,
  productReload,
} from "../Application/ProductPicker"
import { updateSelectionV2 } from "./api/borrowerSideV2Client"
import { track } from "../statsig"
import { STATSIG } from "../statsig/events"

const { Paragraph } = Typography

const getType = (card) => {
  if (card.Arm === null || card.Arm === 0) return "Fixed rate"
  return "ARM " + card.Arm.fixedperiod + "/6"
}

const mapStateToProps = (state) => {
  return {
    hascoborrower: state.application.hascoborrower,
    cohabiting: state.application.cohabiting,
    application: state.application,
    property: state.application.property,
    selection: state.application.selection,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateChangeApplication: (application) => {
    dispatch(act.updateApplication(application));
  },
  updateChangeProgressType: (step, stage) => {
    dispatch(UpdateChangeProgressType(step, stage));
  },
  updateChangeProgress: (tab, index) => {
    dispatch(prgr.UpdateChangeProgress(tab, index));
  },
  updateChangeProgressType: (tab) => {
    dispatch(prgr.UpdateChangeProgressType(tab));
  },
  updateChangeVisitedStage: (step, stage) => {
    dispatch(prgr.UpdateChangeVisitedStage(step, stage));
  },
  changeMainPropertyPurpose: (val) => {
    dispatch(act.ChangeMainPropertyPurpose(val));
  },
  changeMainPropertyAttribute: (t, verb) => {
    dispatch(act.ChangeMainPropertyAttribute(t, verb));
  },
  changeBorrowerInfo: (event, who, verb) => {
    dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb));
  },
  changeBorrowerInfoCheck: (event, who, verb) => {
    dispatch(act.ChangeBorrowerInfo(event.target.checked, who, verb));
  },
  changePhoneInfo: (input, who, verb) => {
    dispatch(act.ChangeBorrowerInfo(input, who, verb));
  },

  updatePreviousAddress: (event, who, verb, n) => {
    dispatch(act.UpdatePreviousAddress(event.target.value, who, verb, n));
  },
  addPreviousAddress: (event, who) => {
    dispatch(act.AddPreviousAddress(event.target.value, who));
  },
  removePreviousAddress: (event, who, n) => {
    dispatch(act.RemovePreviousAddress(event.target.value, who, n));
  },
  clearPreviousAddress: (event, who) => {
    dispatch(act.ClearPreviousAddress(event.target.value, who));
  },
  changeMainProperty: (value, verb) => {
    dispatch(act.ChangeMainProperty(value, verb));
  },
  changeMainPropertyUnits: (event) => {
    dispatch(act.ChangeMainPropertyUnits(event.target.value));
  },
  changeMainPropertyYearBuilt: (event) => {
    dispatch(act.ChangeMainPropertyYearBuilt(event.target.value));
  },
  changeMainPropertyRefinanceYearAcquired: (event) => {
    dispatch(act.ChangeMainPropertyRefinanceYearAcquired(event));
  },
  changeMainPropertyRefinanceOriginalCost: (event) => {
    dispatch(act.ChangeMainPropertyRefinanceOriginalCost(event));
  },
  updateApplicationAttribute: (input, verb) => {
    dispatch(act.UpdateApplicationAttribute(input, verb));
  },
  updateSelectField: (input, verb) => {
    dispatch(act.UpdateSelectField(input, verb));
  },
})

class PrequalLetterV2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingPdf: false,
      purpose: "Purchase", // propagated
      loansize: 0.8 * com.safeParseInt(this.props.property.salesprice),
      show: false,
      download: "",
      url: "",
      showContactModal: false,
      showCreateNewModal: false,
      loadingCreateNew: false,
      showPrequalLetterHistory: false,
      automatedPreQualLetter: false,
    }
    this.prequalLetterHistoryRef = React.createRef()

    this.Loan25 = null
    this.Loan20 = null
    this.Loan10 = null
    // this.fhaLoan = null
    this.count = 0
    this.customerid = com.getCustomerId()
  }

  resolveLoanId = () => this.props.loanId || ""

  // Always write selection/fees to split tables (never loanstates / updatestate).
  persistSelectionToV2 = (patch) => {
    const selection = this.props.selection || {}
    const body = {
      downpayment: patch.downpayment != null ? String(patch.downpayment) : String(selection.downpayment ?? ""),
      paydown: patch.paydown != null ? String(patch.paydown) : String(selection.paydown ?? ""),
      cashout: patch.cashout != null ? String(patch.cashout) : String(selection.cashout ?? ""),
      loansize: patch.loansize != null ? String(patch.loansize) : String(selection.loansize ?? ""),
      mincashout: patch.mincashout != null ? String(patch.mincashout) : String(selection.mincashout ?? ""),
    }
    if (patch.estimatedClosingCosts != null) {
      // fees.toJson() strips internal "_field" keys; raw JSON.stringify does not.
      const feesValue = patch.estimatedClosingCosts
      body.estimatedClosingCosts = typeof feesValue?.toJson === "function"
        ? JSON.parse(feesValue.toJson())
        : feesValue
    }
    updateSelectionV2(body).then((resp) => {
      if (resp?.Application && typeof this.props.onApplicationUpdated === "function") {
        this.props.onApplicationUpdated(resp.Application)
      }
    }).catch((err) => {
      console.error("PrequalLetterV2 persistSelection failed:", err)
    })
  }

  // Borrower-side getFees: no X-Borrower (avoids LO-token 401); persist fees via V2 API.
  getFees = (loanid) => {
    const token = sessionStorage.getItem("ZeitroA")
    this.setState({ loading: true })
    fetch("/data/getFees", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status !== 200) {
        alert("Sorry, an internal error occurred. Please contact your loan officer for assistance.")
        this.setState({ loading: false })
        return
      }
      response.json().then((_fees) => {
        const f = new fees(_fees)
        f.cannotshopservices = _fees.cannotshopservices
        f.canshopservices = _fees.canshopservices
        f.closingcostsfinanced = _fees.closingcostsfinanced
        f.deposit = _fees.deposit
        f.downpayment = _fees.downpayment
        f.fundsforborrower = _fees.fundsforborrower
        f.initialescrowpaymentsatclosing = _fees.initialescrowpaymentsatclosing
        f.othercosts = _fees.othercosts
        f.prepaids = _fees.prepaids
        f.recordingandgovernmentfees = _fees.recordingandgovernmentfees
        f.transfertax = _fees.transfertax
        f.sellerscredits = _fees.sellerscredits
        f.adjustmentsothercredits = _fees.adjustmentsothercredits

        this.props.updateSelectField(f, "estimatedclosingcosts")
        this.persistSelectionToV2({ estimatedClosingCosts: f })
        setTimeout(() => this.getDTI(loanid), 3000)
      })
    }).catch(() => {
      this.setState({ loading: false })
      alert("Network error")
    })
  }

  componentDidMount() {
    const token = com.getUserToken()
    const loanID = this.resolveLoanId()
    fetch("/borrower/get_all_prequal_letters_for_loan", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
      body: JSON.stringify({ loanID }),
    }).then((response) => {
      response.json().then((data) => {
        if (data.length === 0) {
          fetch("/borrower/check-loan-officer-feature", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              Cache: "no-cache",
            },
          }).then((response) => {
            response.json().then((data) => {
              if (data.AutomatedPreQualLetter && !this.isLargeMultifamily()) {
                this.setState({ automatedPreQualLetter: true })
                this.getFees()
              } else {
                // If there are no prequal letters and automated prequal letter is disabled, show the history (which will be empty)
                this.setState({ showPrequalLetterHistory: true })
              }
            })
          })
        } else {
          // If there are prequal letters, show the history, regardless of whether the automated prequal letter is enabled
          console.log(
            `Found ${data.length} prequal letters, displaying history.`
          )
          this.setState({ showPrequalLetterHistory: true })
        }
      });
    });
  }
  // Multifamily (5+ unit) is stored as "commercial". Pricing covers 1 to 4
  // units and would quote it as a one-unit home with no property type, so no
  // automated letter is written for it; the loan officer can still issue one.
  // The interview's V2 application is current; the redux copy is the fallback.
  isLargeMultifamily = () => (this.props.propertyType || this.props.property?.propertytype) === "commercial"

  getDTI = getDTI.bind(this)
  getCitizenship = getCitizenship.bind(this)
  getOccupancy = getOccupancy.bind(this)
  getPropertyType = getPropertyType.bind(this)
  productReload = productReload.bind(this)

  getLTV = () => {
    const { loansize } = this.state
    const { salesprice } = this.props.property
    const ltv = (com.safeParseInt(loansize) * 100) / com.safeParseInt(salesprice)
    const cltv = ((com.safeParseInt(loansize) + com.safeParseInt(this.cltv)) * 100) / com.safeParseInt(salesprice)
    const hcltv = ((com.safeParseInt(loansize) + com.safeParseInt(this.hcltv)) * 100) / com.safeParseInt(salesprice)
    return [ltv, cltv, hcltv]
  }

  askedForAssistance = () => false

  postCheckingAllProducts = () => {
    const hasLetters = this.Loan10 != null || this.Loan20 != null || this.Loan25 != null
    const numberOfLetters = (this.Loan10 != null ? 1 : 0) + (this.Loan20 != null ? 1 : 0) + (this.Loan25 != null ? 1 : 0)
    console.log("After checking all possible preset products.")
    if (hasLetters) {
      console.log(`${numberOfLetters} prequal letter(s) are generated, saving.`)
      this.saveAllPrequals()
    } else {
      console.log("No prequal letters is generated, showing history")
      this.setState({ showPrequalLetterHistory: true })
    }
  }

  /**
   * This function is called when the product picker fails to find a suitable product.
   * It will try to generate a new loan size and get fees again.
   *
   * When this.count reaches 2, it will check if any prequal letters are generated.
   * If not, it will show the history.
   */
  failedProduct = () => {
    const { salesprice } = this.props.property
    switch (this.count) {
      case 0: {
        this.count = 1
        const newloan = parseInt(0.9 * com.safeParseInt(salesprice))
        this.setState({ loading: true, loansize: newloan }, () => { this.getFees() })
        break
      }
      case 1: {
        this.count = 2
        const newloan = parseInt(0.75 * com.safeParseInt(salesprice))
        this.setState({ loading: true, loansize: newloan }, () => { this.getFees() })
        break
      }
      case 2: {
        this.setState({ loading: false })
        this.postCheckingAllProducts()
        break
      }
      default:
        break
    }
  }

  savePrequal = (pr, ltv) => {
    const { salesprice } = this.props.property
    const { email, firstname, lastname } = this.props.application.borrower
    const loansize = parseInt(com.safeParseInt(salesprice) * ltv)
    const downpayment = parseInt(com.safeParseInt(salesprice) - loansize)
    this.props.updateSelectField(downpayment, "downpayment")
    this.props.updateSelectField(loansize, "loansize")
    this.persistSelectionToV2({ downpayment, loansize })

    const data = {
      price: salesprice.toString(),
      loan: loansize.toString(),
      loanType: `${pr.Term} year ${getType(pr)}`,
      isFHA: pr.FHAMIP != null,
      email: email.toLowerCase(),
      name: `${firstname} ${lastname}`,
    }

    this.setState({ loadingPdf: true });

    const token = com.getUserToken()
    fetch("/borrower/save_prequal", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status === 200) {
        this.setState({ showPrequalLetterHistory: true });
        this.prequalLetterHistoryRef.current.fetchData();
      }
    })
  }

  saveAllPrequals = () => {
    const count = [this.Loan25, this.Loan20, this.Loan10].filter((loan) => loan != null).length
    if (count > 0) {
      track(STATSIG.LOAN.PREQUAL_LETTER, "generate", {
        type: "generate",
        count: String(count),
        loan_id: this.props.application?.selection?.selectedloan?.loanid
          || this.props.application?.loanid
          || "",
      })
    }
    if (this.Loan25 != null) this.savePrequal(this.Loan25, 0.75)
    if (this.Loan20 != null) this.savePrequal(this.Loan20, 0.8)
    if (this.Loan10 != null) this.savePrequal(this.Loan10, 0.9)
  }

  cullRate = (products) => {
    if (products.length === 0) return products

    const newproducts = []
    newproducts.push(products[0])

    let base_rate = products[0].base_rate
    for (let i = 1; i < products.length; i++) {
      if (products[i].base_rate !== base_rate) {
        newproducts.push(products[i]);
        base_rate = products[i].base_rate;
      }
    }
    return newproducts
  }

  compareRate = (a, b) => {
    if (a.base_rate !== b.base_rate) return b.base_rate - a.base_rate
    return b.closing_cost - a.closing_cost // take into account remaining credits
  }

  /**
   * This function is called when the product picker finds a suitable product.
   * It will try to generate a new loan size and get fees again.
   *
   * When this.count reaches 2, it will check if any prequal letters are generated.
   * If not, it will show the history.
   */
  processProducts = (products) => {
    this.setState({ loading: true })
    let rearranged = []
    products.forEach((product) => {
      const { propertytype } = this.props.application.property
      const lender = product.Lender

      product.ProductRatesCosts.forEach((pr) => {
        const commonproduct = pr.product
        const ausengine = pr.AUSEngine
        if (propertytype !== "mobilehome") {
          if (commonproduct.Term !== 30) return
        }

        pr.rateCosts.forEach((rate) => {
          let typ = commonproduct.Arm
          if (typ === null || typeof typ === "undefined") typ = 0
          else typ = typ.fixedperiod
          // filter out non-30 day locks
          if (rate.lockDay !== 30) return

          const pdkt = {
            Lender: lender,
            ...commonproduct,
            Aus: ausengine,
            ...rate,
          }
          rearranged.push(pdkt)
        })
      })
    })

    rearranged.sort(this.compareRate)
    rearranged = this.cullRate(rearranged)

    let getBest = (rearranged) => {
      let minAPR = 99.9;
      let maxClosingCost = 10000
      let loan = null
      for (const ln of rearranged) {
        if (ln.closing_cost < 0) continue
        if (ln.closing_cost < maxClosingCost && ln.APR < minAPR) {
          minAPR = ln.APR
          loan = ln
        }
      }

      if (loan !== null) {
        return loan
      }

      for (let ln of rearranged) {
        if (ln.closing_cost > 0) {
          return ln
        }
      }

      return rearranged[0]
    }

    const { loansize } = this.state
    const { salesprice } = this.props.property
    switch (this.count) {
      case 0: {
        this.Loan20 = getBest(rearranged)
        const downpayment = Math.ceil(com.safeParseInt(salesprice) - loansize)
        this.props.updateSelectField(downpayment, "downpayment")
        this.props.updateSelectField(loansize, "loansize")
        this.persistSelectionToV2({ downpayment, loansize })
        this.count = 1
        const newloan = parseInt(0.9 * com.safeParseInt(salesprice))
        this.setState({ loading: true, loansize: newloan }, () => { this.getFees() })
        break
      }
      case 1: {
        this.Loan10 = getBest(rearranged);
        this.count = 2;
        const downpayment = Math.ceil(com.safeParseInt(salesprice) - loansize)
        this.props.updateSelectField(downpayment, "downpayment")
        this.props.updateSelectField(loansize, "loansize")
        this.persistSelectionToV2({ downpayment, loansize })
        const newloan = parseInt(0.75 * com.safeParseInt(salesprice))
        this.setState({ loading: true, loansize: newloan }, () => { this.getFees() })
        break
      }
      case 2: {
        this.Loan25 = getBest(rearranged);
        const downpayment = Math.ceil(com.safeParseInt(salesprice) - loansize)
        this.props.updateSelectField(downpayment, "downpayment")
        this.props.updateSelectField(loansize, "loansize")
        this.persistSelectionToV2({ downpayment, loansize })
        this.setState({ loading: false })
        this.postCheckingAllProducts()
        break
      }
      default:
        break
    }
  }

  render = () => {
    const { showPrequalLetterHistory, automatedPreQualLetter } = this.state

    return (
      <div className="mb-4  text-left text-wrap">
        {showPrequalLetterHistory ? (
          <PreQualLetterHistory ref={this.prequalLetterHistoryRef} loanId={this.resolveLoanId()} />
        ) : automatedPreQualLetter ? (
          <div style={{ padding: "20px" }}>
            <PrequalLetterHeader />
            <Paragraph style={{ marginTop: "20px", marginBottom: "20px" }}>
              We are checking if you qualify for a prequalification letter.
            </Paragraph>
            <Skeleton active />
          </div>
        ) : (
          <div style={{ padding: "20px" }}>
            <PrequalLetterHeader />
            <NoPrequalLetters />
          </div>
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(PrequalLetterV2)
